<template>
  <div id="innerAg">
    <div class="vx-col">
      <vs-prompt
        style=" margin-top: -153px !important;"
        id="widerPopup"
        name="selectProductsPopup"
        vs-title="Ürün listesi"
        vs-accept-text="Ekle"
        vs-cancel-text="Vazgeç"
        vs-button-cancel="border"
        @vs-cancel="closeFields"
        @vs-accept="saveSelectedProducts"
        @vs-close="closeFields"
        :vs-active.sync="openProductPopup"
        :vs-buttons-hidden="true"
      >
        <div>
          <div class="vx-row">
            <div class="vx-col md:w-1/6 w-full">
              <label class="text-sm"><b>Ürün Id</b></label>
              <vs-input type="number" :disabled="true" class="w-full" size="large" v-model="productId" />
            </div>
            <div class="vx-col md:w-2/3 w-full">
              <label class="text-sm"><b>Ürün Adı</b></label>
              <vs-input type="text" :disabled="true" class="w-full" size="large" v-model="productName" />
            </div>
            <div class="vx-col mt-5">
              <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
              <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
            </div>
          </div>
          <div class="mt-5">
            <ag-grid-vue
              @row-selected="onRowSelected"
              @cellValueChanged="onCellValueChanged"
              :gridOptions="gridOptions"
              style="height: 20vh;"
              class="ag-theme-material ag-grid-table"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              rowSelection="multiple"
              colResizeDefault="shift"
              :animateRows="true"
              :floatingFilter="true"
              :pagination="true"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              :suppressRowClickSelection="true"
              rowDataChangeDetectionStrategy="IdentityCheck"
            ></ag-grid-vue>
            <vs-pagination :total="totalPages" :max="maxPageNumbers" v-model="currentPage" />
          </div>
          <div class="flex justify-end">
            <div><vs-button @click.stop="saveSelectedProducts()">Ekle</vs-button></div>
            <div class="ml-5"><vs-button color="danger" @click.stop="closeFields">Kapat</vs-button></div>
          </div>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { repository } from "@/_services/repository.js";
import ProductSearch from "../../../Search/ProductSearch.vue";

import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

export default {
  components: {
    AgGridVue,
    ProductSearch,
  },
  props: {
    openProducts: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      taxIncluded: true,
      temporary: [],
      gridOptions: {
        pagination: true,
        rowHeight: 40,
        headerHeight: 40,
        autoGroupColumnDef: {
          headerName: " row groups! ",
        },
      },
      productSearchPopupParent: false,
      maxPageNumbers: 7,
      gridApi: null,
      productId: null,
      productName: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true,
      },

      columnDefs: [
        {
          field: "productId",
          hide: true,
        },

        {
          checkboxSelection: true,
          headerName: "Seç",
          field: "productCategory",
          width: 50,
          filter: true,
          editable: false,
        },
        {
          headerName: "Ürün",
          field: "productName",
          width: 100,
          editable: false,
          hide: true,
        },
        {
          headerName: "Stok",
          field: "stock",
          width: 100,
          editable: false,
        },

        {
          headerName: "Depo",
          field: "wareHouse",
          width: 150,
          filter: true,
          editable: false,
        },

        {
          headerName: "Tür",
          field: "salePriceCurrencyLogo",
          width: 100,
          editable: false,
        },
        {
          headerName: "Satış Fiyatı(Kur)",
          field: "sellPriceOrjCurr",
          filter: "agNumberColumnFilter",
          width: 150,
          editable: false,
        },

        {
          headerName: "İndirimli Fiyat(Kur)",
          field: "sellPriceDiscountedOrjCurr",
          filter: "agNumberColumnFilter",
          width: 150,
          editable: false,
        },
        {
          headerName: "Satış Fiyatı(TL)",
          field: "sellPriceOrjTl",
          filter: "agNumberColumnFilter",
          width: 150,
          editable: false,
        },

        {
          headerName: "İndirimli Fiyat(TL)",
          field: "sellPrice",
          filter: "agNumberColumnFilter",
          width: 150,
          editable: false,
        },
        {
          headerName: "İndirim Oranı",
          field: "b2BDiscountPercent",
          filter: "agNumberColumnFilter",
          width: 100,
          editable: false,
    
        },

        {
          headerName: "Adet",
          field: "amount",
          filter: "agNumberColumnFilter",
          width: 100,
          editable: true,
        },
      ],
      productDataForAggrid: [],
    };
  },
  computed: {
    openProductPopup: {
      get() {
        return this.openProducts;
      },
      set() {},
    },
    paginationPageSize() {
      return 20;
    },

    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    ProductSearchPopupClosedParent: async function(v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.productId = v.productId;
        this.productName = v.productName;
        this.getProducts();
      } else {
        this.productId = null;
        this.productName = null;
      }
    },

    saveSelectedProducts() {
      this.gridApi.stopEditing();
      let rows = this.gridOptions.api.getSelectedRows();

      this.$emit("hideProducts", 1, [].concat(rows), true);
      this.productDataForAggrid = [];
      this.gridApi.setRowData(this.productDataForAggrid);
      this.productId = null;
      this.productName = null;
      this.$swal.fire({ icon: "success", title: "Ürün eklendi." });
    },

    closeFields() {
      this.$emit("hideProducts", 0, false);
    },
    onCellValueChanged(dataGridProperties) {},
    onRowSelected(event) {
      //Burda amount vs. hatalı ile popup uyarı yazabilirsin
      //this.gridApi.getSelectedRows().forEach((rows) => this.selectedRows.push(rows));
    },

    setSelectedItems(api) {
      if (this.productDataForAggrid.length == api.getDisplayedRowCount()) {
        for (let i = 0; i < this.temporary.length; i++) {
          let query = (this.temporary[i].wareHouseId && this.temporary[i].wareHouseId.toString()) + "_" + this.temporary[i].productId;
          let node = api.getRowNode(query);
          if (node) {
            node.setSelected(true);
          }
        }
        this.gridApi.sizeColumnsToFit();
        clearInterval(window.watcher);
        window.watcher = 0;
      }
    },

    getProducts: async function() {
      let data = await repository.postEntity("B2B/getProductsV1Search", { ProductId: this.productId }).then((r) => r.list);
      this.temporary = [].concat(this.value);
      if (Array.isArray(this.temporary) && this.temporary.length > 0) this.taxIncluded = !!this.temporary[0].taxIncluded;
      for (let i = 0; i < this.temporary.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (this.temporary[i].productId == data[j].productId && this.temporary[i].wareHouseId == data[j].wareHouseId) {
            let x = Object.assign({}, this.temporary[i]);
            x.wareHouse = data[j].wareHouse;
            data.splice(j, 1)[0];
            x.sellPrice = this.taxIncluded ? x.priceWithTaxes || x.sellPrice : x.priceDiscounted;
            data.unshift(x);
            break;
          }
        }
      }
      this.productDataForAggrid = data;
      this.gridApi.setRowData(this.productDataForAggrid);
      window.watcher = setInterval(this.setSelectedItems, 50, this.gridApi);
    },
  },
  created() {},
  mounted() {
    this.gridOptions.getRowNodeId = function(data) {
      return (data.wareHouseId && data.wareHouseId.toString()) + "_" + data.productId.toString();
    };
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
};
</script>

<style>
@media screen and (max-width: 575px) {
  .ag-theme-material .ag-cell {
    padding-left: 0px !important;
    padding-right: 0px !important;
    font-size: 10px !important;
  }
}
</style>
